import React from 'react';
import Addicon from '../../media/add.png';
import { Image } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';

class View extends React.Component {

  state = {
    file: Addicon,
  }

  componentDidMount() {
    if (this.props.image) {
      this.setState({
        file: this.props.image,
      });
    }
    else {
      this.setState({
        file: Addicon,
      });
    }
  }

  handleFile = e => {
    if (!this.props.menuPermission.edit) {
      alert('Access is Denied!!!');
      return;
    }
    this.updateLocalfile(e.target.files[0]);
    this.uploadimage(e.target.files[0])
  }

  uploadimage(file) {
    let context = this;
    if (this.props.image) {
      let modelId = this.props.modelId;
      let oldImage = this.props.image_name;
      var formData = new FormData();
      formData.append('oldImage', oldImage);
      formData.append('file', file);
      $.ajax({
      type: 'POST',
      processData: false,
      contentType: false,
      data: formData,
      url: Server() + 'addmenu/modeldetails/updatingmodelimage.php',
      success: function(data)
      {
      },
      error: function(error) {
      }
      });
    }
    else {
      let modelId = this.props.modelId;
      var formData = new FormData();
      formData.append('modelid', modelId);
      formData.append('file', file);
      $.ajax({
      type: 'POST',
      processData: false,
      contentType: false,
      data: formData,
      url: Server() + 'addmenu/modeldetails/uploadimage.php',
      success: function(data)
      {

      },
      error: function(error) {
      }
      });
    }
  }

  updateLocalfile(value) {
    let reader  = new FileReader();
    let context = this;
    reader.addEventListener("load", function () {
      let out = reader.result;
      context.setState({
        file: out
      });
    }, false);
    if (value) {
      reader.readAsDataURL(value);
    }
  }

  render() {
    return (
      <div>
        <input id={this.props.modelId} type="file" onChange={this.handleFile} style={{display: 'none'}}/>
        <label htmlFor={this.props.modelId}>
          <Image src={this.state.file} size='small'
          style={{width: 80, height: 50, cursor: 'pointer'}}
          id='image' />
        </label>
      </div>
    );
  }
}

export default View;
